import { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../i18n';
import { TIME_OF_DAY } from '../lib/data';
import TaskCard from '../components/TaskCard';
import AddTaskModal from '../components/AddTaskModal';

export default function Opgaver() {
    const { t } = useI18n();
    const [tasks, setTasks] = useState([]);
    const [adding, setAdding] = useState(false);

    const load = () => {
        const today = new Date().toISOString().slice(0, 10);
        api.get('/tasks', { params: { date: today } }).then((r) => setTasks(r.data || [])).catch(() => {});
    };
    useEffect(() => { load(); }, []);

    const done = tasks.filter((x) => x.done).length;
    const pct = tasks.length ? Math.round((done / tasks.length) * 100) : 0;

    return (
        <div className="px-5 pt-10 pb-32 max-w-2xl mx-auto">
            <div className="flex items-end justify-between mb-4">
                <div>
                    <p className="text-[10px] uppercase tracking-widest font-semibold text-brand-ink3">{done} / {tasks.length} {t('task.done').toLowerCase()}</p>
                    <h1 className="font-serif text-3xl sm:text-4xl text-brand-ink mt-1">{t('nav.tasks')}</h1>
                </div>
                <button data-testid="btn-add-task" onClick={() => setAdding(true)} className="inline-flex items-center gap-1.5 bg-brand-green text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-brand-greenDark transition-colors">
                    <Plus size={15} strokeWidth={2.2} /> {t('task.add')}
                </button>
            </div>

            <div className="h-2 bg-brand-bg2 rounded-full overflow-hidden mb-8">
                <div className="h-full bg-brand-green transition-all duration-700" style={{ width: `${pct}%` }} />
            </div>

            {TIME_OF_DAY.map((time) => {
                const list = tasks.filter((task) => task.time_of_day === time);
                if (!list.length) return null;
                return (
                    <section key={time} className="mb-8">
                        <h2 className="text-[10px] uppercase tracking-widest font-semibold text-brand-ink3 mb-3">{time}</h2>
                        <div className="space-y-2.5 stagger">
                            {list.map((task) => <TaskCard key={task.id} task={task} onChanged={load} />)}
                        </div>
                    </section>
                );
            })}

            {(() => {
                const other = tasks.filter((task) => !TIME_OF_DAY.includes(task.time_of_day));
                if (!other.length) return null;
                return (
                    <section className="mb-8">
                        <h2 className="text-[10px] uppercase tracking-widest font-semibold text-brand-ink3 mb-3">Other</h2>
                        <div className="space-y-2.5 stagger">
                            {other.map((task) => <TaskCard key={task.id} task={task} onChanged={load} />)}
                        </div>
                    </section>
                );
            })()}

            {tasks.length === 0 && (
                <div className="bg-brand-card border border-dashed border-brand-border rounded-3xl p-12 text-center">
                    <div className="text-4xl mb-2">🌿</div>
                    <p className="text-sm text-brand-ink2">No tasks — garden at peace.</p>
                </div>
            )}

            <AddTaskModal open={adding} onClose={() => setAdding(false)} onAdded={() => load()} />
        </div>
    );
}
